import React from 'react';
import MenuItemSeparator from 'tradera-components/site-header/dropdown-menu-item-separator';
import MenuItem from 'tradera-components/site-header/dropdown-menu-item';
import ExpandableMenuItem from 'tradera-components/site-header/dropdown-menu-item-expandable';
import GtmService from 'static/script/app/ui/google-tagmanager-service';
import { getMenuGaAttributes } from 'tradera-components/site-header/site-header.analytics';
import STRINGS from 'static/script/constants/strings';
import { getReturnUrl } from 'tradera-utils/login';
import logger from 'logger';
import {
    useTranslator,
    useUrlLocalizer,
    useCurrentLanguage
} from 'tradera-lang/translate';
import { useQualtive } from 'tradera-hooks/use-qualtive';
import { SURVEYS } from 'tradera-constants/surveys';
import ChatIcon from '@tradera/blueprint/theme/icons2/chat.svg?jsx';
import InfoIcon from '@tradera/blueprint/theme/icons2/info.svg?jsx';
import { useMenuHeightFix } from 'tradera-hooks/use-menu-height-fix';
import { openChatBot } from './chat-bot-loader';

const onIframeLoad = (e, closeMenu) => {
    const iframe = e.target;
    if (iframe) {
        const iframeDocument =
            iframe.contentDocument || iframe.contentWindow.document;
        if (iframeDocument) {
            iframeDocument.body.addEventListener('keydown', e => {
                if (e.keyCode === 27) {
                    closeMenu();
                }
            });
        }
    }
};

const getGaAttributes = label =>
    getMenuGaAttributes('Top navigation', 'Login menu', label);

const trackOnClick = label => {
    GtmService.trackAction('Top navigation', 'Login menu', `Link - ${label}`);
};

const SignInMenuContent = ({ closeMenu, redirectUrl }) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    const { language } = useCurrentLanguage();
    const menuContentRef = useMenuHeightFix();
    const { isQualtiveEnabled, openQualtiveModal } = useQualtive();

    const isChatBotEnabled = language === 'sv';

    return (
        <>
            <iframe
                ref={menuContentRef}
                className="w-100"
                src={toLocalizedUrl(
                    `${window.location.origin}/login${getReturnUrl(
                        redirectUrl
                    )}&login-modal=true`
                )}
                id="sign-in-modal"
                title="Login"
                name="LoginIframe"
                data-sign-in-modal
                onLoad={e => onIframeLoad(e, closeMenu)}>
                <p>{STRINGS.IFRAME_NOT_SUPPORTED}</p>
            </iframe>
            <ExpandableMenuItem
                label={t('siteheader_needHelp')}
                className="site-dropdown__item-with-icon text-inter-medium"
                icon={<InfoIcon className="icon" />}
                border={false}>
                <MenuItem
                    label={t('siteheader_forgotPassword')}
                    link={toLocalizedUrl('/login/forgotusercredentials')}
                    className="site-dropdown__item-with-icon"
                    icon={<InfoIcon className="icon" />}
                    gaAttributes={getGaAttributes('Forgot')}
                />
                <MenuItem
                    label={t('siteheader_helpPages')}
                    link="https://info.tradera.com/"
                    className="site-dropdown__item-with-icon"
                    icon={<InfoIcon className="icon" />}
                    gaAttributes={getGaAttributes('Help pages')}
                />
                <MenuItem
                    label={t('siteheader_contactCustomerService')}
                    link="https://info.tradera.com/kontakt/"
                    className="site-dropdown__item-with-icon"
                    icon={<ChatIcon className="icon" />}
                    gaAttributes={getGaAttributes('Customer service')}
                />

                {isChatBotEnabled && (
                    <MenuItem
                        label={t('siteheader_chatWithBot')}
                        className="site-dropdown__item-with-icon"
                        icon={<ChatIcon className="icon" />}
                        onClick={async () => {
                            try {
                                openChatBot();
                                closeMenu();
                            } catch (e) {
                                logger(e);
                            }

                            trackOnClick('Chat with JUNO');
                        }}
                    />
                )}
                {isQualtiveEnabled && (
                    <MenuItem
                        label={t('siteheader_feedback')}
                        className="site-dropdown__item-with-icon"
                        icon={<ChatIcon className="icon" />}
                        onClick={() => {
                            openQualtiveModal(SURVEYS.general);
                            trackOnClick('Leave feedback Qualtive');
                        }}
                    />
                )}
                {/* NOTE: Fix for iPhone menu making bottom element unclickable */}
                <MenuItemSeparator className="site-dropdown__separator--bottom d-lg-none" />
            </ExpandableMenuItem>
        </>
    );
};

export default SignInMenuContent;
